import { useState } from 'react';
import { Save, ShieldCheck } from 'lucide-react';
import { useAuth } from '../context/Auth';
import { api, message } from '../lib/api';
import { PageHeader, Avatar, UploadButton, Btn, ErrorNotice } from '../components/shared';
import { toast } from 'sonner';

export default function ParentProfile() {
  const { user, setUser } = useAuth();
  const [photoId, setPhotoId] = useState(user.photo_id || null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const changed = photoId !== (user.photo_id || null);
  const save = async e => {
    e.preventDefault(); setBusy(true); setError('');
    try {
      const result = await api.put('/account/photo', { photo_id: photoId });
      setUser(result.data);
      toast.success('Your profile photo is saved.');
    } catch (e) { setError(message(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="page-enter parent-profile-page">
      <PageHeader eyebrow="YOUR CORNER OF THE TEAM" title="My profile" />
      <form className="parent-profile-form" onSubmit={save}>
        <section className="parent-profile-identity">
          <Avatar name={user.name} photo={photoId} size="large" />
          <div><h2 data-testid="parent-profile-name">{user.name}</h2><p data-testid="parent-profile-email">{user.email}</p><span data-testid="parent-profile-role">Parent / guardian</span></div>
        </section>
        <section className="parent-profile-photo-section">
          <h2>Profile photo</h2>
          <UploadButton purpose="parent_profile" photoId={photoId} onUpload={setPhotoId} id="parent-profile-photo-upload" />
          <p className="form-hint">Any photo from your phone or computer · Up to 10 MB</p>
          <div className="parent-photo-privacy" data-testid="parent-photo-privacy"><ShieldCheck size={16} /><span>Private to your account. Separate from your athlete’s photo.</span></div>
        </section>
        <ErrorNotice text={error} />
        <div className="form-actions"><Btn secondary type="button" data-testid="parent-profile-discard-button" disabled={busy || !changed} onClick={() => setPhotoId(user.photo_id || null)}>Discard changes</Btn><Btn type="submit" data-testid="parent-profile-save-button" disabled={busy || !changed}><Save />{busy ? 'Saving…' : 'Save profile'}</Btn></div>
      </form>
    </div>
  );
}